<script setup lang="ts">
const error = useError()

const wittyMessage = computed(() => {
  if (error.value?.statusCode === 404) {
    return error.value.statusMessage || 'Nothing to see here — this gallery never made it out of the darkroom.'
  }

  return error.value?.statusMessage || 'Something went wrong behind the lens.'
})
</script>

<template>
  <main class="min-h-screen flex flex-col items-center justify-center px-6 text-center text-white bg-black">
    <p class="text-sm text-gray-400 mb-2">
      Error {{ error?.statusCode || 500 }}
    </p>
    <h1 class="text-3xl md:text-4xl font-semibold mb-4">
      {{ wittyMessage }}
    </h1>
    <p class="text-gray-400 mb-8">
      Try heading back before the film burns.
    </p>

    <div class="flex gap-3">
      <UButton to="/" color="primary" label="Take me out of this empty darkroom" />
    </div>
  </main>
</template>
